var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.NotSync-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "NotSync-st0",
    d: "M9.7,4.6C9.4,2.8,7.8,1.5,6,1.5S2.6,2.8,2.3,4.6C1,4.9,0,6.1,0,7.5c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3 C12,6.1,11,4.9,9.7,4.6z M6.6,9.6c0,0.2-0.1,0.3-0.2,0.3H5.6c-0.2,0-0.2-0.1-0.2-0.2V8.9c0-0.1,0.1-0.2,0.2-0.2h0.9 c0.1,0,0.2,0.1,0.2,0.3L6.6,9.6L6.6,9.6z M6.6,8.1C6.5,8.2,6.4,8.2,6.3,8.2H5.7c-0.3,0-0.4-0.2-0.4-0.5C5.2,5.6,5.1,4.4,5.1,4.1 c0-0.1,0.1-0.2,0.3-0.2h1.1c0.2,0,0.3,0.1,0.3,0.3C6.7,6.7,6.6,8.1,6.6,8.1L6.6,8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSync);
export default __webpack_public_path__ + "static/media/NotSync.df2bb442f22c3385860fa6de2a9ae6e9.svg";
export { ForwardRef as ReactComponent };